import { render } from "./ManagersTable.vue?vue&type=template&id=9d3854c6"
import script from "./ManagersTable.vue?vue&type=script&lang=js"
export * from "./ManagersTable.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/nahodka.xpage.dev/htdocs/public/local/client-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__